import { z } from 'zod';

const AG2_APP_ID_ERROR = 'AG 2.0 APP-ID must match the format APP-12345';
const NAME_ERROR = 'Name must be between 5 and 100 characters';

export const applicationNameSchema = z.string().min(5, NAME_ERROR).max(100, NAME_ERROR);

export const ag2AppIdSchema = z
  .string()
  .max(9, AG2_APP_ID_ERROR)
  .regex(/^APP-\d+$/, AG2_APP_ID_ERROR);
